import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Button,
  CardContent,
  TextField,
  Typography,
  Stack,
  Avatar,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CircularProgress,
  IconButton
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';
import GooglePlaces from 'src/components/GooglePlaces';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from 'src/Api';
import { getDecade } from 'date-fns';
import Iconify from 'src/components/Iconify';

const CustomerCompanyProfile = () => {
  const user = 'kofked';
  const location = useLocation();

  const roleName = user?.role?.role_name;
  const { t } = useTranslation();
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [name, setname] = useState(user?.name);
  const [about_me, setabout_me] = useState(user?.about_me ? user?.about_me : null);
  const [phone, setPhone] = useState(user?.contact_no ? user?.contact_no : '');
  const [nationality, setnationality] = useState(null);
  const [genderlist, setgenderlist] = useState([]);
  const [gender, setgender] = useState(null);
  const [data, setdata] = useState('');
  const [file, setfile] = useState({ image: data?.avatar, file: '' });
  const navigate = useNavigate();
  const [objAfter, setobjAfter] = useState({
    name: data?.name,
    file: false
  });
  const token = localStorage.getItem('token');
  const handleNationality = (event) => {
    setnationality(event.target.value);
  };
  const handleGender = (event) => {
    setgender(event.target.value);
  };
  const { userid } = location.state || {};

  useEffect(() => {
    getcompanycustomer();
  }, [userid]);

  useEffect(() => {
    setfile({ image: data?.avatar });
  }, [data]);

  function getcompanycustomer() {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const params = new URLSearchParams();
    params.append('id', userid);
    // params.append('id', 10);
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(`${api.customer_profile_list}?${params.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          console.log('result data of company ===>', result.data);
          setdata(result?.data);
        } else {
          setdata('');
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  }

  // console.log('data', data);

  const EducationCard = (row) => {
    console.log('====education', row);
    const { education_level, institution, field_of_study, graduate_date } = row;
    return (
      <Card
        variant="soft"
        sx={{
          padding: 2,
          width: '100%',
          overflow: 'initial'
        }}
      >
        <CardContent>
          <Typography
            style={{
              position: 'absolute',
              top: -10,
              zIndex: 1
            }}
          >
            {education_level?.name}
          </Typography>
          <Grid container spacing={2} className="top_column">
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Education Level'}
                type="text"
                value={education_level?.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Institution'}
                type="text"
                value={institution?.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Field of Study'}
                type="text"
                value={field_of_study?.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Graduated Date'}
                type="text"
                value={graduate_date}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const JobTitle = (row) => {
    const { recent_job_title, job_location, company_name } = row;
    return (
      <Card
        variant="soft"
        sx={{
          padding: 2,
          borderRadius: 2,
          boxShadow: 1,
          width: '100%',
          overflow: 'initial',
          // backgroundColor: 'red',
          border: 1
        }}
      >
        <CardContent>
          <Typography
            style={{
              position: 'absolute',
              top: -18,
              zIndex: 1,
              backgroundColor: '#F9FAFB',

              padding: 5
            }}
          >
            {recent_job_title?.name}
          </Typography>
          <Grid container spacing={2} className="top_column">
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Job Title'}
                type="text"
                value={recent_job_title?.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Job Location'}
                type="text"
                value={job_location?.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Company'}
                type="text"
                value={company_name?.name}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'Start Date'}
                type="text"
                value={row?.start_date}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                disabled={true}
                id="outlined-error-helper-text"
                fullWidth
                label={'End Date'}
                type="text"
                value={row?.end_date}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>

          {/* <Typography mb={0.5} sx={{ fontSize: 14, color: 'text.secondary' }}>
            <strong>Job Title:</strong> {recent_job_title?.name || 'N/A'}
          </Typography>
          <Typography mb={0.5} sx={{ fontSize: 14, color: 'text.secondary' }}>
            <strong>Job Location:</strong> {job_location?.name || 'N/A'}
          </Typography>
          <Typography mb={0.5} sx={{ fontSize: 14, color: 'text.secondary' }}>
            <strong>Company:</strong> {company_name?.name || 'N/A'}
          </Typography>
          <Typography mb={0.5} sx={{ fontSize: 14, color: 'text.secondary' }}>
            <strong>Start Date:</strong> {row?.start_date || 'N/A'}
          </Typography>
          <Typography mb={1} sx={{ fontSize: 14, color: 'text.secondary' }}>
            <strong>End Date:</strong> {row?.end_date || 'N/A'}
          </Typography> */}
        </CardContent>
      </Card>
    );
  };

  // console.log('customer', data?.working_experience);
  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <IconButton
        style={{
          marginRight: 12,
          height: 40,
          width: 70,
          borderRadius: 5,
          backgroundColor: 'rgba(0, 110, 230,0.1)'
        }}
        onClick={() => navigate(-1)}
      >
        <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#3F90DF' }} />
      </IconButton>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t('Employee Profile')}
      </Typography>

      {!loading && (
        <CardContent>
          <Stack
            mb={2}
            direction={{ xs: 'column' }}
            style={{ display: 'flex', flexDirection: 'row' }}
            className="image_center"
          >
            <Box
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {file && (
                <Avatar
                  alt="Remy Sharp"
                  src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
                  sx={{ width: 80, height: 80, marginBottom: 5 }}
                  className="image_center"
                />
              )}
            </Box>
          </Stack>
          <Grid container spacing={2} className="top_column">
            <>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  id="outlined-error-helper-text"
                  fullWidth
                  label={'First Name'}
                  type="text"
                  value={data?.first_name}
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  id="outlined-error-helper-text"
                  fullWidth
                  label={'Last Name'}
                  type="text"
                  value={data?.last_name}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  value={data?.residence_location?.name}
                  label={'Residence Location'}
                  onChange={handleNationality}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                ></TextField>
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  value={data?.nationality?.name}
                  label={'Nationality'}
                  onChange={handleNationality}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                ></TextField>
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  value={data?.dob}
                  label="Birth Date"
                  onChange={handleNationality}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                ></TextField>
              </Grid>
              <Grid item lg={6} sm={12} md={12}>
                <TextField
                  disabled={true}
                  fullWidth
                  // select
                  value={data?.gender}
                  label={'Gender'}
                  onChange={handleGender}
                  className="width_full_status"
                  InputLabelProps={{ shrink: true }} // Correct prop for label shrink
                >
                  {genderlist?.map((option) => (
                    <MenuItem key={option.id} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </>
          </Grid>

          <Accordion
            sx={{
              '&:before': {
                display: 'none'
              }
            }}
            style={{ marginTop: 10, backgroundColor: 'transparent' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ bgcolor: '#f0f0f0', borderRadius: 2 }} // Set background color here
            >
              Education Detail
            </AccordionSummary>

            {/* <AccordionDetails style={{ padding: 0 }}>
              <Grid container spacing={2} mt={1} className="top_column">
                {data?.education_details?.map((e, index) => (
                  <Grid item xs={12} key={index}>
                    {EducationCard(e)}
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails> */}

            <AccordionDetails style={{ padding: 0 }}>
              <Grid container spacing={2} mt={1} className="top_column">
                {data?.education_details?.length > 0 ? (
                  data.education_details.map((e, index) => (
                    <Grid item xs={12} key={index}>
                      {EducationCard(e)}
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Card
                      variant="soft"
                      style={{
                        padding: '20px',
                        textAlign: 'center',
                        width: '100%'
                        // backgroundColor: '#f9f9f9'
                      }}
                    >
                      <Typography variant="h6" color="textSecondary">
                        No record found
                      </Typography>
                    </Card>{' '}
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              '&:before': {
                display: 'none'
              }
            }}
            style={{ marginTop: 10, backgroundColor: 'transparent' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ bgcolor: '#f0f0f0', borderRadius: 2 }} // Set background color here
            >
              Work Experience
            </AccordionSummary>
            {/* <AccordionDetails style={{ padding: 0 }}>
              <Grid container spacing={2} mt={1} className="top_column">
                {data?.working_experience?.map((e, index) => (
                  <Grid item xs={12} key={index}>
                    {JobTitle(e)}
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails> */}

            <AccordionDetails style={{ padding: 0 }}>
              <Grid container spacing={2} mt={1} className="top_column">
                {data?.working_experience?.length > 0 ? (
                  data?.working_experience.map((e, index) => (
                    <Grid item xs={12} key={index}>
                      {JobTitle(e)}
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12}>
                    <Card
                      variant="soft"
                      style={{
                        padding: '20px',
                        textAlign: 'center',
                        width: '100%'
                        // backgroundColor: '#f9f9f9'
                      }}
                    >
                      <Typography variant="h6" color="textSecondary">
                        No record found
                      </Typography>
                    </Card>{' '}
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </CardContent>
      )}

      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-40%, -50%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100vw',
            height: '100vh',
            // backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 9999
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
    </Box>
  );
};

export default CustomerCompanyProfile;
